import { useEffect, useState } from 'react';
import { convertHTMLToProsemirrorJSON } from './scoringHelpers';

const useConvertHTMLToProsemirrorJSON = (rubricData) => {
  const [itemRubric, setItemRubric] = useState([]);

  useEffect(() => {
    if (rubricData) {
      const response = JSON.parse(rubricData).data;
      const rubricReferences = Object.keys(response);

      rubricReferences.sort((a, b) => {
        const valueA = parseInt(a.split('_').slice(-1)[0], 10);
        const valueB = parseInt(b.split('_').slice(-1)[0], 10);

        return valueA - valueB;
      });

      const itemRubricDataArrayPromise = rubricReferences.map(
        (rubricReference) => {
          const itemRubricData = (response[rubricReference].length &&
            response[rubricReference][0] &&
            response[rubricReference][0].data) || { stimulus: '', options: [] };

          const stimulusPromise = convertHTMLToProsemirrorJSON(
            itemRubricData.stimulus,
          );

          const optionsPromiseArray = itemRubricData.options.map((item) =>
            Promise.all([
              convertHTMLToProsemirrorJSON(item.description),
              convertHTMLToProsemirrorJSON(item.additional_feedback),
              (item.criterias &&
                item.criterias.length &&
                Promise.all(
                  item.criterias.map((criteria) =>
                    convertHTMLToProsemirrorJSON(criteria.description),
                  ),
                ).then((convertedCriterias) =>
                  convertedCriterias.map((description) => ({ description })),
                )) ||
                [],
            ]),
          );

          const optionsPromise = Promise.all(optionsPromiseArray).then(
            (items) =>
              items.map((item) => ({
                feedback: item[0] || {
                  content: [{ content: [], type: 'paragraph' }],
                  type: 'doc',
                },
                additional_feedback: item[1] || {
                  content: [{ content: [], type: 'paragraph' }],
                  type: 'doc',
                },
                criterias: item[2],
              })),
          );

          return Promise.all([stimulusPromise, optionsPromise]).then(
            (results) => ({
              title: itemRubricData.title,
              stimulus: results[0],
              options: results[1],
            }),
          );
        },
      );

      Promise.all(itemRubricDataArrayPromise).then((results) =>
        setItemRubric(results),
      );
    }
  }, [rubricData]);

  return [itemRubric];
};

export default useConvertHTMLToProsemirrorJSON;
